import { apiRequest } from './client';

export const SURVEY_SOURCES = ['app_store', 'google_play', 'friends', 'social_media', 'search', 'advertising', 'other'] as const;
export interface SurveyAnswers {
  source: string;
  source_text: string;
  missing_text: string;
  paying_text: string;
}
export type SurveyAction = 'submit' | 'later' | 'decline';
export interface SurveyMetadata { language: string; app_version: string; platform: string }
export interface SurveyClaim { claimed: boolean; canSnooze?: boolean }
export const getSurveyStatus = () => apiRequest<{ eligible: boolean; final: boolean }>('/api/survey/status');
export const claimSurvey = () => apiRequest<SurveyClaim>('/api/survey/claim', { method: 'POST', body: {} });
export const answerSurvey = (action: SurveyAction, answers: SurveyAnswers, meta: SurveyMetadata) =>
  apiRequest<{ saved: boolean }>('/api/survey/answer', { method: 'POST', body: { action, ...answers, ...meta } });

export interface SurveyRow {
  user_id: number;
  language: string;
  app_version: string;
  platform: string;
  answered_at: string;
  source: string | null;
  source_text: string;
  missing_text: string;
  paying_text: string;
}
export interface SurveyList { rows: SurveyRow[]; total: number; languages: string[] }
const adminPath = (language: string) => `/api/admin/survey?language=${encodeURIComponent(language)}`;
export const getSurveyAnswers = (language: string, offset: number) => apiRequest<SurveyList>(`${adminPath(language)}&offset=${offset}`);
export const getSurveyPreview = () => apiRequest<{ enabled: boolean; minTurns: number; preview: boolean }>('/api/admin/survey/preview');
export async function downloadSurveyCsv(language: string): Promise<void> {
  const csv = await apiRequest<string>(`${adminPath(language)}&format=csv`);
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = 'lorath-umfrage.csv';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
